// Common helper for image dimension check
const checkImageDimensions = (file, minWidth, minHeight, maxWidth, maxHeight) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;
      if (
        width >= minWidth &&
        height >= minHeight &&
        width <= maxWidth &&
        height <= maxHeight
      ) {
        resolve(true);
      } else {
        reject(
          `Image must be between ${minWidth}x${minHeight} and ${maxWidth}x${maxHeight} pixels. Uploaded image is ${width}x${height}.`
        );
      }
    };

    img.onerror = () => reject('Invalid image file');
  });
};

// ✅ Banner validator
export const validateBannerImage = async (file) => {
  const maxSizeMB = 3;
  if (file.size > maxSizeMB * 1024 * 1024) {
    throw new Error(`Banner image too large. Max size is ${maxSizeMB}MB`);
  }
  await checkImageDimensions(file, 1000, 200, 2000, 600); // Example dims
};

// ✅ Profile image validator
export const validateProfileImage = async (file) => {
  const maxSizeMB = 0.5;
  if (file.size > maxSizeMB * 1024 * 1024) {
    throw new Error(`Profile image too large. Max size is ${maxSizeMB}MB`);
  }
  await checkImageDimensions(file, 100, 100, 800, 800);
};

// ✅ Product carousel image validator
export const validateCarouselImage = async (file) => {
  const maxSizeMB = 2;
  if (file.size > maxSizeMB * 1024 * 1024) {
    throw new Error(`Carousel image too large. Max size is ${maxSizeMB}MB`);
  }
  await checkImageDimensions(file, 800, 600, 2000, 2000);
};

// ✅ Document / File validator
export const validateDocumentFile = (file) => {
  const maxSizeMB = 10;
  if (file.size > maxSizeMB * 1024 * 1024) {
    throw new Error(`File too large. Max size is ${maxSizeMB}MB`);
  }
  const allowedExts = ['pdf', 'docx', 'odf', 'pptx', 'odp', 'zip', 'rar', '7z'];
  const ext = file.name.split('.').pop().toLowerCase();
  if (!allowedExts.includes(ext)) {
    throw new Error(`Invalid file type: ${ext}`);
  }
};

// Helper that runs validation only when needed
export const validateIfNeeded = async (fieldName, files) => {
  if (fieldName === 'banner') {
    for (const f of files) await validateBannerImage(f);
  } else if (fieldName === 'profile') {
    for (const f of files) await validateProfileImage(f);
  }
  // For all other fields: no-op
};
